import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import {
  useLanguage,
  METRICS_ACCOUNT_CHANGE_LANGUAGE,
  METRICS_ACCOUNT_LANGUAGE,
  useAnalytics,
} from '@xolv-mybrightlink/common';
import { useCallback } from 'react';

export const LanguageSetting = () => {
  const { language: currentLanguage, updateLanguage } = useLanguage();
  const analytics = useAnalytics();
  const changeLanguage = useCallback(
    (languageCode: string) => {
      updateLanguage(languageCode);
      analytics.trackAction(METRICS_ACCOUNT_CHANGE_LANGUAGE, {
        [METRICS_ACCOUNT_LANGUAGE]: languageCode,
      });
    },
    [analytics, updateLanguage],
  );

  return (
    <>
      <Button
        variant={currentLanguage === 'en' ? 'contained' : 'outlined'}
        disableElevation
        onClick={() => changeLanguage('en')}
        sx={{
          borderRadius: 8,
          px: 11,
          mr: 8,
          py: 3,
        }}
      >
        <FormattedMessage id='account.setting.language.name.english' />
      </Button>
      <Button
        variant={currentLanguage === 'es' ? 'contained' : 'outlined'}
        disableElevation
        onClick={() => changeLanguage('es')}
        sx={{
          borderRadius: 8,
          px: 11,
          py: 3,
        }}
      >
        <FormattedMessage id='account.setting.language.name.spanish' />
      </Button>
    </>
  );
};
